import { store } from 'redux/store';

import { downloadBlob } from 'utils/downloadBlob';

import {
  getDocumentReplacedWithTags,
  ReplaceDocumentTagsSources,
} from 'modules/documents/api/replaceDocumentTags';
import { getDocumentBlob } from 'modules/_shared/components/CKEditor/utils/getDocumentBlob';

import { hasTemplateTags } from './hasTemplateTags';

type GenerateDocumentProps = {
  documentId: string;
  documentName: string;
  documentHtml?: string;
  sources: ReplaceDocumentTagsSources;
  language: string;
  footerHtml: string;
  watermarkText?: string;
};

export const generateDocumentWithTags = async ({
  documentId,
  documentName,
  documentHtml,
  sources,
  language,
  footerHtml,
  watermarkText = '',
}: GenerateDocumentProps) => {
  const hasTags = hasTemplateTags(documentHtml || '');

  const result =
    hasTags || !documentHtml
      ? await store.dispatch(
          getDocumentReplacedWithTags({
            documentId,
            sources,
            language,
          })
        )
      : { html: documentHtml };

  const blob = await getDocumentBlob({
    html: result?.html || '',
    footerHtml: footerHtml || '',
    watermarkText,
  });

  downloadBlob(blob, documentName || '');
};
